module.exports = __webpack_public_path__ + "files/b52b409eb38398258fc95c2200d4247a.png";